export default __webpack_public_path__ + "static/aaron-307c18c0ff71793ba4c9e23f0471f06b.webp";